import { Map, fromJS } from 'immutable';

/** Immutable updateIn passes explicit null through — default params do not apply. */
export const mergeImmutableMap = (current, patch) =>
  (current && Map.isMap(current) ? current : Map()).merge(fromJS(patch));
